import { styled, StyledSnackbar } from '@raskrask-dk/rr-components'

export const StyledDetails = styled('div', {
    br: '$2',
    margin: '0px auto',
    maxW: 900,

    '@mobile': {
        pb: 70,
    },

    '@desktop': {
        p: '$4 $3',
    },

    [`& ${StyledSnackbar}`]: {
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        right: 'auto',
        top: '10%',
        bottom: 'auto',
        animation: 'none',
    },
})

export const HelpField = styled('div', {
    br: '$1',
    border: '1px solid $primary400',

    variants: {
        variant: {
            Default: {
                bgc: '$primary200',
            },
            OneOff: {
                bgc: 'white',
            },
        },
    },

    '@mobile': {
        p: '$3',
    },

    '@desktop': {
        p: '$4',
    },
})
